import axios from 'axios';
import Loading from 'quasar/src/plugins/Loading.js';;

export default {
  namespaced: true,
  state: {
    pageIndex: 0,
    showAmount: 21,
    imgList: [],
    isLastPage: false
  },
  mutations: {
    SET_PAGE_INDEX(state, payload) {
      state.pageIndex = payload;
    },
    SET_SHOW_AMOUNT(state, payload) {
      state.showAmount = payload;
    },
    SET_IMG_LIST(state, payload) {
      state.imgList = payload;
    },
    SET_IS_LAST_PAGE(state, payload) {
      state.isLastPage = payload;
    }
  },
  actions: {
    // 拿相簿資料
    showAlbumImgs(context, payload) {
      Loading.show();
      let api = `${process.env.VUE_APP_API_PATH}/showAlbumImgs?PageIndex=${context.state.pageIndex}&ShowAmount=${context.state.showAmount + payload}`;
      axios
        .post(api)
        .then(res => {
          context.commit('SET_IMG_LIST', res.data.ImgList);
          context.commit('SET_IS_LAST_PAGE', res.data.IsLastPage);
          Loading.hide();
        })
        .catch(error => {
          console.log(error);
          Loading.hide();
        });
    }
  }
};
